import { IAppState } from '../../../../../AppModulesWrapper';
import { selectPackages } from './selectPackages';
import { createSelector } from 'reselect';

export const selectIsPackagesAvailable = createSelector(
  (state: IAppState) => selectPackages(state),
  packages => Boolean(packages?.length),
);
